import styled from "styled-components";

import { TopicElement } from "shared/types";
import { Sheet } from "features/media/components/atoms/Sheet";

interface Props {
  data: TopicElement;
}

export default function Quote({ data }: Props) {
  return (
    <Sheet>
      <BlockQuote cite={data.siteUrl}>{data.title}</BlockQuote>
      <Origin href={data.siteUrl} target="_blank">
        {`出典 : ${data.siteUrl}`}
      </Origin>
    </Sheet>
  );
}

const BlockQuote = styled.blockquote`
  font-weight: 300;
  font-size: 12px;
  letter-spacing: 0.35px;
  line-height: 28px;
  color: #3c424a;
  font-family: ヒラギノ明朝 ProN;
  white-space: pre-wrap;
`;

const Origin = styled.a`
  font-weight: 300;
  font-size: 10px;
  letter-spacing: 0.29px;
  line-height: 10px;
  color: #cf73b2;
  word-break: break-all;
  margin-top: 12px;
`;
